import { atomFamily } from 'recoil';

import { iaRa } from 'lib/helpers/utility';

import { MAX_DOCK_TABS } from './dockTabs';
import { persistPerWorkspace } from './dockWorkspace';

const DOCK_TABS_STORAGE_KEY = 'myriad:dock-tabs';

const sanitize = (value) => {
  const tabs = iaRa(value?.tabs)
    .filter((tab) => typeof tab?.id === 'string' && typeof tab?.path === 'string')
    .slice(0, MAX_DOCK_TABS + 1)
    .map((tab) => ({
      id: tab.id,
      path: tab.path,
      label: typeof tab.label === 'string' ? tab.label : null
    }));
  const activeId = tabs.some((tab) => tab.id === value?.activeId) ? value.activeId : null;
  const entries = Object.fromEntries(
    Object.entries(value?.entries || {}).filter(([, id]) => typeof id === 'string')
  );
  return { tabs, activeId: activeId || tabs[0]?.id || null, entries };
};

// Marks a dock brought back from the session (a reload, a practice switched back to) until its
// first arrival, which must not overwrite the tab it was left in. Never stored: `sanitize` drops it.
const revive = (value) => (value.tabs.length ? { ...value, isRestored: true } : value);

// One per workspace (see dockWorkspace). `entries` maps router location keys to tabs, so Back and
// Forward return to the right tab.
export const dockTabsState = atomFamily({
  key: 'dockTabsState',
  default: { tabs: [], activeId: null, entries: {} },
  effects: persistPerWorkspace({ storageKey: DOCK_TABS_STORAGE_KEY, sanitize, revive })
});
